import { useEffect, useState } from 'react';
import './styles/Modal.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faWindowMaximize,
  faWindowRestore,
} from '@fortawesome/free-solid-svg-icons';

interface NoticeMessage {
  severity: 'success' | 'warning' | 'error';
  content: string;
}

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  message?: NoticeMessage;
  className?: string;
  isFullScreenRequired?: boolean;
  resetMessage: (msg: NoticeMessage) => void;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  className = '',
  resetMessage,
  isFullScreenRequired = false,
}) => {
  // const [showMessage, setShowMessage] = useState<boolean>(false);
  const [isFullScreen, setIsFullScreen] = useState<boolean>(false);

  const handleToggleFullScreen = async () => {
    if (!document.fullscreenElement) {
      await document.documentElement.requestFullscreen();
      setIsFullScreen(true);
    } else {
      await document.exitFullscreen();
      setIsFullScreen(false);
    }
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullScreen(!!document.fullscreenElement);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () =>
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
  }, []);
  const modelContentClasses = `modal-content ${className} ${
    isFullScreen ? 'fullscreen' : ''
  }`;

  const getBackgroundColor = (severity: string) => {
    switch (severity) {
      case 'success':
        return 'green';
      case 'warning':
        return 'orange';
      case 'error':
        return 'red';
      default:
        return 'none';
    }
  };

  return (
    <div className="modal-overlay">
      <div className={modelContentClasses}>
        <div className="button-row">
          <div className="message-container"></div>
          {isFullScreenRequired && (
            <button className="maximize-button">
              <FontAwesomeIcon
                size="2x"
                color="white"
                icon={isFullScreen ? faWindowMaximize : faWindowRestore}
                onClick={handleToggleFullScreen}
              />
            </button>
          )}

          <button className="close-button" onClick={onClose}>
            X
          </button>
        </div>
        {children}
      </div>
    </div>
  );
};

export default Modal;
